export const Why2SVG = () => {
  return (
    <svg
      width="125"
      height="114"
      viewBox="0 0 125 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Why2 SVG</title>
      <g id="3a490696" clipPath="url(#8aaee0de)">
        <g id="6f1058e7">
          <path
            id="4eeda81c"
            d="M23.9619 23.6226C23.865 45.0556 21.5457 66.3843 16.9742 87.3252C16.3552 90.1666 19.368 87.8472 19.7111 86.2737C24.3497 65.0196 26.751 43.3702 26.848 21.6165C26.8554 19.1331 23.9694 22.228 23.9619 23.6226Z"
            fill="#343339"
          />
          <path
            id="dcdcec1d"
            d="M61.4662 25.0761C64.8072 25.3595 68.1408 25.6653 71.4743 26.0232C73.2119 26.2097 75.6207 26.0829 77.2539 26.7019C78.8871 27.3208 79.0736 26.933 79.0512 28.9913C79.0139 32.034 77.4777 35.7032 76.8139 38.716C76.1129 41.9153 75.4492 45.1146 74.8228 48.3288C72.3394 61.1783 70.6689 74.1544 70.117 87.235C69.9977 90.0988 74.2485 90.3598 74.3679 87.6005C75.039 71.9395 77.336 56.4651 80.6173 41.1472C81.4078 37.4408 82.3027 33.7567 83.1305 30.0578C83.6003 27.9622 83.9881 25.6205 82.3922 23.9053C80.6546 22.0409 77.3062 22.2646 74.9868 21.9887C70.6987 21.489 66.3957 21.0788 62.0927 20.7134C59.4229 20.4897 58.6398 24.8375 61.4588 25.0686L61.4662 25.0761Z"
            fill="#343339"
          />
          <path
            id="980ea393"
            d="M24.4529 23.1227C27.3017 23.2346 30.1505 23.339 32.9993 23.4583C35.6691 23.5627 36.4522 19.2149 33.6332 19.1031C30.8142 18.9912 27.9356 18.8793 25.0868 18.7675C22.417 18.6631 21.634 23.0183 24.4529 23.1227Z"
            fill="#343339"
          />
          <path
            id="b91d781c"
            d="M16.8471 93.1861C25.3935 95.3115 34.1785 94.0288 42.8218 93.2383C52.5316 92.3509 62.2488 91.4559 71.9586 90.5685C73.7633 90.4044 75.4338 86.3624 73.0474 86.5787C63.8224 87.4214 54.5899 88.2716 45.3649 89.1143C36.1398 89.957 27.489 91.4112 18.7637 89.241C16.9515 88.7936 14.7664 92.6641 16.8471 93.1861Z"
            fill="#343339"
          />
          <path
            id="f247d8c8"
            d="M36.3924 93.4927C38.1747 99.1008 40.1062 104.776 42.5896 110.123C43.4845 112.055 44.4764 114.023 46.7659 114.374C50.3753 114.926 55.1556 112.42 58.5563 111.361C74.8064 106.305 90.8253 100.54 106.605 94.1788C108.962 93.2317 108.261 89.8981 105.554 90.9869C91.653 96.5876 77.5582 101.689 63.2844 106.253C59.6749 107.409 56.0506 108.535 52.4187 109.623C51.0241 110.041 48.9584 111.04 47.5564 110.034C46.7584 109.467 46.1693 107.386 45.7815 106.484C43.6933 101.584 41.8961 96.5279 40.2852 91.4568C39.5842 89.2419 35.751 91.5015 36.3849 93.4927H36.3924Z"
            fill="#343339"
          />
          <path
            id="02b1db08"
            d="M86.3957 41.8932C96.3515 57.4721 98.999 76.0191 106.322 92.7614C107.307 95.0136 110.223 91.777 109.447 90.017C101.989 72.969 99.2152 54.2877 89.0729 38.418C87.9319 36.6356 85.3367 40.2451 86.3882 41.8932H86.3957Z"
            fill="#343339"
          />
          <path
            id="0275734d"
            d="M40.8677 50.1275C40.8677 37.1275 43.3677 21.1275 51.3677 22.1275C59.3677 23.1275 49.8677 62.6273 40.8677 62.6273C31.8677 62.6273 31.3677 44.6273 32.3677 32.1273C33.3677 19.6273 41.8677 7.62732 51.3677 9.12732C60.8677 10.6273 63.8677 21.6272 62.3677 32.1273"
            stroke="url(#d2fb46da)"
            strokeWidth="5"
            strokeLinecap="round"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="d2fb46da"
          x1="47.3669"
          y1="9"
          x2="47.3669"
          y2="62.6273"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8EEBD2" />
          <stop offset="0.605" stopColor="#4D93DE" />
          <stop offset="1" stopColor="#FFC9BD" />
        </linearGradient>
        <clipPath id="8aaee0de">
          <rect width="125" height="114" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
